import React from 'react';
import { Flex, View, Card, Text } from '@smarterservices/smarter-ui';
import Chat from './Chat';
import { ControlBar } from './ControlBar';
import CONSTANTS from '../../../config/constants';
import {
  usePlayerStore,
  useAppStore,
  useLayoutStore,
  getStore,
} from '../../../stores/StoreContext';
import { RoomContext } from '@livekit/components-react';

const Communication = () => {
  const AppStore = getStore('appStore');
  const canHaveLiveVideo = usePlayerStore((state) => state.canHaveLiveVideo);
  const isRoomConnected = useAppStore((state) => state.isRoomConnected);

  const sessionDetailsHeight = useLayoutStore(
    (state) => state.containers.sessionDetails.size.height
  );

  const controls = {
    chat: !!AppStore.enabledComponents?.chat,
    microphone: !!AppStore.enabledComponents?.microphone,
    screenShare: !!AppStore.enabledComponents?.screenShare,
    camera: !!AppStore.enabledComponents?.camera,
    leave: !!AppStore.enabledComponents?.leave,
    settings: !!AppStore.enabledComponents?.settings,
  };

  return (
    <Flex>
      <Flex.Item
        as="div"
        width="45%"
        align="start"
        padding="none small none none"
        position="relative"
      >
        <Card>
          <Card.Header
            background="brand"
            padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
          >
            <Card.Title>
              <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>Chat</Text>
            </Card.Title>
          </Card.Header>
          <Card.Body height={`${sessionDetailsHeight - 50}px`}>
            <Chat />
          </Card.Body>
        </Card>
      </Flex.Item>
      <Flex.Item as="div" shouldGrow width="55%" align="start">
        {canHaveLiveVideo && isRoomConnected && (
          <RoomContext.Provider value={AppStore.room}>
            <ControlBar
              controls={controls}
              microphoneEnabledLabel="End Voice Call"
              microphoneDisabledLabel="Start Voice Call"
              cameraEnabledLabel="Camera"
              cameraDisabledLabel="Camera"
              screenShareEnabledLabel="Share screen"
              screenShareDisabledLabel="Stop screen share"
            />
          </RoomContext.Provider>
        )}
      </Flex.Item>
    </Flex>
  );
};

export default Communication;
